import {Autocomplete, Box, createFilterOptions, TextField} from "@mui/material";
import React from "react";
import {PersonApiGet, useGetPersonQuery} from "./people_api";
import {AutocompleteProps} from "../../components/SearchBox";
import AvatarImage from "../storage/AvatarImage";


export default ({setFieldValue, value, name, error, label}: AutocompleteProps<PersonApiGet>) => {

    const {data} = useGetPersonQuery({active: true});

    return <Autocomplete
        id={name}
        options={data || []}
        sx={{minWidth: "150px"}}
        value={value}
        onChange={(e, v: PersonApiGet | null) => {
            setFieldValue(name, v)
        }}
        getOptionKey={o => o.id}
        getOptionLabel={(option: PersonApiGet) => {
            return option.lastName + " " + option.firstName;
        }}
        filterOptions={createFilterOptions({
            stringify: (option) => option.lastName + " " + option.firstName + " " + option.partnerCode,
        })}
        renderOption={(props, option: PersonApiGet) => {
            const {key, ...rest} = props
            return <Box key={key} component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} {...rest}>
                <AvatarImage image_url={option.avatar_url} bucket={"avatars"}/> {option.lastName} {option.firstName}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}
                label={label}
                error={Boolean(error)}
                helperText={error}
            />
        )}
    />

}
